// src/components/CaseStudySection.js
import React from "react";
import { School, Lightbulb, CheckCircle } from "lucide-react";
import CaseStudyIllustration from "../assets/school-dashboard.svg";

const iconClass = "w-6 h-6 text-[#4C47DC]";

const caseStudy = [
  {
    icon: <School className={iconClass} />,
    title: "The Challenge",
    description:
      "Schools lacked a unified platform to manage admissions, academics, and internal communication efficiently.",
  },
  {
    icon: <Lightbulb className={iconClass} />,
    title: "Our Solution",
    description:
      "We developed a scalable school management solution with modules for admission, attendance, academic records, and fee tracking.",
  },
  {
    icon: <CheckCircle className={iconClass} />,
    title: "Impact",
    description:
      "Enabled schools to go fully digital, reduce admin workload, improve parent-teacher communication, and streamline daily operations.",
  },
];

const CaseStudySection = () => {
  return (
    <section className="bg-white py-16 px-4" id="case-study">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* Left: Case Study Content */}
        <div>
          <h2 className="text-3xl font-bold text-[#4C47DC] mb-8">
            Case Study: Smart School Solution
          </h2>
          <ul className="space-y-6">
            {caseStudy.map((item, index) => (
              <li key={index} className="flex items-start space-x-4 group">
                <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 transition-transform duration-300 group-hover:scale-105">
                  {item.icon}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-600">{item.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Right: Illustration */}
        <div className="hidden md:block">
          <img
            src={CaseStudyIllustration}
            alt="Case Study Illustration"
            className="w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default CaseStudySection;
